import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Input, Button, Row, Col, message } from "antd";
import { withTranslation } from "react-i18next";
import hu from "../../static/hu.png";
import de from "../../static/de.png";
import en from "../../static/en.png";
import i18n from "../../i18n";
import { getCompaniesByToken } from "../../actions/company";
import "./guest-register.scss";
import { updateVehicle, createVehicleFromMessage } from "../../actions/parking";
import axios from "axios";

const mapDispatchToProps = (dispatch) => {
  return {
    getCompaniesByToken: (token) => dispatch(getCompaniesByToken(token)),
    updateVehicle: (id, params) => dispatch(updateVehicle(id, params)),
    createVehicleFromMessage: (code, licensePlateNumber) =>
      dispatch(createVehicleFromMessage(code, licensePlateNumber)),
  };
};
class ConnectedGuestParking extends Component {
  state = {
    licensePlateNumber: "",
    token: this.props.match.params.token,
    hasReservation: false,
    host: null,
    company: null,
  };
  formRef = React.createRef();
  componentDidMount = async () => {
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL + "/api";
    const queryParams = new URLSearchParams(this.props.location.search);
    this.setState({
      code: queryParams.get("code"),
    });
    await axios
      .get(
        "/2.0.0/parking/parking-reservations/get-reservation-with-code/" +
          queryParams.get("code")
      )
      .then((response) => {
        this.setState({
          hasReservation: true,
        });
        console.log(response.data);
      })
      .catch((err) => {
        message.error(
          this.props.t("guest-has-deleted-the-reservation-error-message")
        );
      });
    await this.props.getCompaniesByToken(this.props.match.params.token);
    await this.getGuestVehicle();
    this.props.parking
      ? this.setLicensePlateNumber()
      : this.setState({ licensePlateNumber: "" });
  };

  getGuestVehicle = async () => {
    await this.props.createVehicleFromMessage(this.state.code);
  };

  setLicensePlateNumber = async () => {
    this.setState({
      licensePlateNumber: this.props.parking.licencePlateNumber,
    });
    this.formRef.current.setFieldsValue({
      licensePlateNumber: this.props.parking.licencePlateNumber,
    });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  submitForm = async () => {
    if (this.props.parking.licensePlateNumber !== undefined) {
      let objectToSend = {
        licensePlateNumber: this.state.licensePlateNumber,
        active: true,
      };
      await this.props.updateVehicle(this.props.parking.id, objectToSend);
      if (this.props.status) {
        message.success(this.props.t("save-success"));
      } else {
        message.error(this.props.t("save-fail"));
      }
    } else {
      await this.props.createVehicleFromMessage(
        this.state.code,
        this.state.licensePlateNumber
      );
      if (this.props.status) {
        message.success(this.props.t("save-success"));
      } else {
        message.error(this.props.t("save-fail"));
      }
    }
  };

  render() {
    const companyRadios = [];
    this.props.companies.forEach((company) =>
      companyRadios.push(
        <div>
          <img
            alt={company.name}
            src={`${process.env.REACT_APP_BASE_URL}/api/1.0.0/company/logo/${company.logoName}`}
            style={{ padding: "1em", width: "100%" }}
          />
          <div style={{ textAlign: "center" }}>{company.name}</div>
          <div
            style={{
              alignItems: "center",
              backgroundColor: "#00aea9",
              borderRadius: "50%",
              display: this.state.company === company.id ? "flex" : "none",
              height: "2em",
              justifyContent: "center",
              position: "absolute",
              right: "1em",
              top: "1em",
              width: "2em",
            }}
          ></div>
        </div>
      )
    );

    return (
      <Row>
        <Col span={24}>
          <div
            style={{
              padding: "20px",
              backgroundColor: "#00aea9",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <div style={{ width: "20%", maxWidth: "75px" }}>
              <img
                src={de}
                alt="de_flag"
                width={"100%"}
                onClick={() => this.changeLanguage("de")}
                style={{
                  opacity: i18n.language === "de" ? "1" : "0.7",
                  paddingBottom: "10px",
                  borderBottom: i18n.language === "de" ? "3px solid white" : "",
                }}
              />
            </div>
            <div style={{ width: "20%", maxWidth: "75px" }}>
              <img
                src={hu}
                alt="hu_flag"
                width={"100%"}
                onClick={() => this.changeLanguage("hu")}
                style={{
                  opacity: i18n.language === "hu" ? "1" : "0.7",
                  paddingBottom: "10px",
                  borderBottom: i18n.language === "hu" ? "3px solid white" : "",
                }}
              />
            </div>
            <div style={{ width: "20%", maxWidth: "75px" }}>
              <img
                src={en}
                alt="en_flag"
                width={"100%"}
                onClick={() => this.changeLanguage("en")}
                style={{
                  opacity: i18n.language === "en" ? "1" : "0.7",
                  paddingBottom: "10px",
                  borderBottom: i18n.language === "en" ? "3px solid white" : "",
                }}
              />
            </div>
          </div>
          {this.state.hasReservation === true ? (
            <div>
              <div style={{ backgroundColor: "#00aea9" }}>
                <h1
                  style={{
                    textAlign: "center",
                    color: "#ffffff",
                    fontSize: "2.2rem",
                  }}
                >
                  {this.props.t("parking-wanted-label")}
                </h1>
              </div>
              <Form onFinish={this.submitForm} ref={this.formRef}>
                <Form.Item
                  name="licensePlateNumber"
                  rules={[
                    {
                      required: true,
                      message: this.props.t(
                        "guest-register-license-plate-nubmer"
                      ),
                      whitespace: false,
                    },
                  ]}
                  style={{
                    padding: "1em",
                  }}
                >
                  <Input
                    value={this.state.licensePlateNumber}
                    name="licensePlateNumber"
                    placeholder={this.props.t(
                      "guest-register-license-plate-nubmer-placeholder"
                    )}
                    style={{ borderRadius: "25px", fontSize: "1.5rem" }}
                    onChange={this.handleChange}
                  />
                </Form.Item>
                <Form.Item style={{ textAlign: "center" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      fontSize: "2.2rem",
                      height: "5%",
                      borderRadius: "50px",
                      width: "60%",
                    }}
                  >
                    {this.props.t("save-button-label")}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "red",
                fontSize: "3rem",
                fontWeight: "bold",
              }}
            >
              {this.props.t("guest-has-deleted-the-reservation")}
            </div>
          )}
        </Col>
      </Row>
    );
  }
}
const mapStateToProps = (state) => ({
  companies: state.companyReducer.companies,
  vehicle: state.parkingReducer.vehicle,
  status: state.parkingReducer.status,
  parking: state.parkingReducer.parking,
});
const GuestParking = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectedGuestParking)
);
export default GuestParking;
